const ROOT = 'SN/APP';
const SET_TRANSLATION = `${ROOT}/SET_TRANSLATION`;

export { SET_TRANSLATION };
